<ng-container *ngIf="!isServer else ssrBaner">
    <div class="banner-wrapper fixed-width" [@bannerAnimation]="bannerState">
        <swiper [pagination]="true" *ngIf="topBanner" [config]="config">
            <ng-template swiperSlide *ngFor="let item of topBanner; trackBy: trackByBannerItems">
                <div class="cursor-pointer">
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
                        <div class="picsum-img-wrapper desktop">
                            <img *ngIf="item.desktopNewImage" alt="{{item.name}}" class="desktop-banner swiper-lazy" [attr.data-src]="item?.forceOriginalImage ? item?.originalDesktopNewImage?.url : item?.desktopNewImage?.url" >
                            <div class="swiper-lazy-preloader"></div>
                            <div class="caption-bg"></div>
                            <div *ngIf="item.buttonLink" class="carousel-caption desktop">
                                <div class="banner-text" fxLayoutAlign="center start" fxLayout="column">
                                    <div class="spacer"></div>
                                    <span class="caption-title" [innerHTML]="item.titleText"></span>
                                    <span class="caption-subtitle" [innerHTML]="item.description"></span>
                                </div>
                                <button (click)="openLink(item)" class="caption-btn" mat-stroked-button color="primary">{{ this.isAuthenticated ? item.loggedButtonLabel : item.buttonLabel}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </swiper>
    </div>
</ng-container>

<ng-template #ssrBaner>
    <ng-container *ngIf="!!topBanner">
        <div class="banner-wrapper fixed-width">
            <div class="swiper-slide cursor-pointer">
                <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
                    <div class="picsum-img-wrapper desktop">
                        <img *ngIf="topBanner[0].desktopNewImage" alt="{{topBanner[0].name}}" src="{{ topBanner[0].desktopNewImage.url }}" class="desktop-banner" alt="desktop slide">
                        <div class="caption-bg"></div>
                        <div *ngIf="topBanner[0].buttonLink" class="carousel-caption desktop">
                            <div class="banner-text" fxLayoutAlign="center start" fxLayout="column">
                                <div class="spacer"></div>
                                <span class="caption-title" [innerHTML]="topBanner[0].titleText"></span>
                                <span class="caption-subtitle">{{topBanner[0].description}}</span>
                            </div>
                            <button (click)="openLink(topBanner[0])" class="caption-btn" mat-stroked-button color="warn">{{ this.isAuthenticated ? topBanner[0].loggedButtonLabel : topBanner[0].buttonLabel}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>